export default "__VITE_ASSET__D_U_4wIp__"